var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
export default class AcademicPlanStatuseservice {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("hit");
            const apiClient = getApiClient();
            const response = yield apiClient.get("/academicPlanStatuses/search/findByNameContainingIgnoreCase", {
                params: { search, sort: "name", order: "ASC", size: 30 },
            });
            return response.data._embedded.academicPlanStatuses;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/academicPlanStatuses/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.academicPlanStatuses;
        });
    }
}
